import { merge } from 'es-toolkit';

/**
 * Deep merges two objects recursively.
 * Unlike shallow merge, this will merge nested objects as well.
 *
 * @param target - The target object to merge into
 * @param source - The source object to merge from
 * @returns A new object with deeply merged properties
 */
export function deepMerge<T extends Record<string, any>>(target: T, source: Partial<T>): T {
  // es-toolkit's merge does deep merge by default
  // Cast source to any to avoid type issues with Partial
  return merge(target, source as any) as T;
}
